import { render, staticRenderFns } from "./AddSeveralAcademicGroup.vue?vue&type=template&id=bc6e6688"
import script from "./AddSeveralAcademicGroup.vue?vue&type=script&lang=js"
export * from "./AddSeveralAcademicGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports